import { IStyle, mergeStyleSets } from "@fluentui/react";
// import { getScrollBarWidth } from "../core/utils";

const scrollablePaneStyles: IStyle = {
  position: "fixed",
  top: 48,
  //bottom: 20,
  borderRadius: "4px",
};

export const shellStyles = mergeStyleSets({
  scrollablePaneCollapsed: {
    ...scrollablePaneStyles,
    right: 0,
    bottom: 0,
    left: 0,
  } as IStyle,
  scrollablePaneExpand: {
    ...scrollablePaneStyles,
    right: 0,
    bottom: 0,
    left: 0,
  } as IStyle,
  scrollablePaneEmbedded: {
    ...scrollablePaneStyles,
    right: 0,
    bottom: 0,
    left: 0, // no left nav rail when embedded in Dynamics
  } as IStyle,
  rootDiv: {
    paddingRight: "0px",
    paddingLeft: "0px",
  } as IStyle,
  dividerLine: {
    width: "100%",
    height: "1px",
    backgroundColor: "black",
    marginBottom: "20px",
  } as IStyle,
  rowGap: {
    height: "30px",
  } as IStyle,
  mainPanelCollapsed: {
    padding: "20px 0",
    '> div[class*="grow"] div[class*="grow"] + div:nth-child(2)' : {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    }
  } as IStyle,
  mainPanelExpand: {
    padding: "0 0",
  } as IStyle,
});

// Generated by GitHub Copilot | Updated on: 2026-10-06 | Removed obsolete left-nav content offsets.
